<template lang="pug">

    div.card(v-bind:title='fileModel.filename')

        .ui.inverted.dimmer(v-bind:class='{ active: !fileModel.isProcessed }')
            .ui.primary.elastic.loader

        .content
            .right.floated
                i.link.trash.icon(v-tooltip="'Datei löschen'" v-on:click="remove" v-if="canModified")
                i.link.linkify.icon(v-tooltip="'Hashlink für Datei erstellen'" v-on:click="showHashlinkModal"  v-if="canHashlink")
                i.link.download.icon(v-tooltip="'Datei downloaden'" v-on:click="download" v-if="canDownload")
            .head {{ fileModel.filename }}

        .image(v-if="isProcessed")
            img.ui.image(v-bind:src="'/downloads/' + fileModel.id + '?thumbnail'")

        .content(v-if="!hideDetails")
            .description
                i.clock.outline.icon
                | {{ date }} um {{ time }} Uhr
            .description
                i.hdd.outline.icon
                | {{ size }} MiB

            //- Nur anzeigen wenn "Druckdaten"
            .ui.form(v-if="productFileModel.type === 'PRINTING_DATA'")
                .grouped.fields

                    //- Finale Druckdaten
                    .field
                        .ui.checkbox
                            input(
                                type="checkbox"
                                v-bind:checked="areFinalPrintData"
                                v-bind:id="areFinalPrintDataElId"
                                v-bind:disabled='firstReviewUserId || secondReviewUserId'
                                v-on:click.prevent="persistProperty('areFinalPrintData', areFinalPrintData ? 'Finale Druckdaten zurückziehen?' : 'Druckdaten als final markieren?', !areFinalPrintData, 'Finale Druckdaten bestätigt', 'Finale Druckdaten zurückgezogen')"
                            )
                            label(v-bind:for="areFinalPrintDataElId") Finale Druckdaten

                    //- Erstprüfung
                    .field(v-if='$auth.isZmuekish')
                        .ui.checkbox
                            input(
                                type="checkbox"
                                v-bind:checked="firstReviewUserId"
                                v-bind:id="firstReviewUserIdElId"
                                v-bind:disabled='!areFinalPrintData || (firstReviewUserId && secondReviewUserId)'
                                v-on:click.prevent="persistUserIdToProperty('firstReviewUserId', firstReviewUserId ? 'Erstprüfung zurückziehen?' : 'Erstprüfung durchgeführt?', !firstReviewUserId, 'Erstprüfung bestätigt', 'Erstprüfung zurückgezogen')"
                            )
                            label(v-bind:for='firstReviewUserIdElId') Erstprüfung

                    //- Zweitprüfung
                    .field(v-if='$auth.isZmuekish')
                        .ui.checkbox
                            input(
                                type="checkbox"
                                v-bind:checked="secondReviewUserId"
                                v-bind:id="secondReviewUserIdElId"
                                v-bind:disabled='!areFinalPrintData || (firstReviewUserId && secondReviewUserId)'
                                v-on:click.prevent="persistUserIdToProperty('secondReviewUserId', secondReviewUserId ? 'Zweitprüfung zurückziehen?' : 'Zweitprüfung durchgeführt?', !secondReviewUserId, 'Zweitprüfung bestätigt', 'Zweitprüfung zurückgezogen')"
                            )
                            label(v-bind:for='secondReviewUserIdElId') Zweitprüfung

            //- Nur anzeigen wenn Freigabe-PDF
            .ui.form(v-if="productFileModel.type === 'FORM_PROOF'")
                .grouped.fields

                    //- Freigabe MP
                    .field
                        .ui.checkbox(v-if='$auth.isZmuekish')
                            input(
                                type="checkbox"
                                v-bind:checked="releasedByMediaProduction"
                                v-bind:disabled="releasedByPurchaser && releasedByMediaProduction"
                                v-bind:id="releasedByMediaProductionElId"
                                v-on:click.prevent="persistProperty('releasedByMediaProduction', releasedByMediaProduction ? 'Freigabe zurückziehen?' : 'Freigabe erteilen?', !releasedByMediaProduction, 'Medienproduktion: Freigabe erteilt', 'Medienproduktion: Freigabe zurückgezogen')"
                            )
                            label(v-bind:for="releasedByMediaProductionElId") Freigabe MP

                    //- Freigabe Auftraggeber
                    .field
                        .ui.checkbox
                            input(
                                type="checkbox"
                                v-bind:checked="releasedByPurchaser"
                                v-bind:disabled="releasedByPurchaser && releasedByMediaProduction"
                                v-bind:id="releasedByPurchaserElId"
                                v-on:click.prevent="persistProperty('releasedByPurchaser', releasedByPurchaser ? 'Freigabe zurückziehen?' : 'Freigabe erteilen?', !releasedByPurchaser, 'Auftraggeber: Freigabe erteilt', 'Auftraggeber: Freigabe zurückgezogen')"
                            )
                            label(v-bind:for="releasedByPurchaserElId")
                                span(v-if='$auth.isZmuekish') Freigabe Auftraggeber
                                span(v-else) Freigabe

        .content
            .ui.fluid.dropdown(ref="typeDropdown" v-bind:class="{ disabled: !canModified }")
                .text {{ type }}
                i.dropdown.icon
                .menu
                    .item(data-value="MAILING_LIST") Adressverteiler
                    .item(data-value="PRINTING_DATA" v-show="canBePrintingData") Druckdaten
                    .item(data-value="FORM_PROOF" v-show="canBeFormProof") Freigabe-PDF
                    .item(data-value="OUTLINE_PUNCH") Kontur/Stanze
                    .item(data-value="DELIVERY_NOTE") Lieferschein
                    .item(data-value="SKETCH") Skizze
                    .item(data-value="OTHER") Sonstiges

        modal(ref="hashlinkModal")
            span(slot="header") Hashlinks

            div(slot="content")
                hashlink-form(slot='content' v-bind:file-model="fileModel")
                div(v-show='hashlinkModels.length > 0')
                    h4.ui.horizontal.divider Erstellte Hashlinks
                    hashlink-table(v-bind:hashlink-models='hashlinkModels')

            div.right.aligned(slot="footer")
                a.ui.right.labeled.icon.button(v-on:click='closeHashlinkModal()')
                    i.remove.icon
                    | Schließen

</template>

<script>
    import * as R from 'ramda'
    import { to_ddmmyyyy, to_hhmm } from '@/utils/date'
    import { to_mb } from '@/utils/size'
    import Modal from '@/components/app/Modal'
    import HashlinkForm from './thumbnail/HashlinkForm'
    import HashlinkTable from './thumbnail/HashlinkTable'

    export default {
        components: { HashlinkForm, HashlinkTable, Modal },

        computed: {

            areFinalPrintData() {
                return R.prop('areFinalPrintData', this.productFileModel)
            },

            canModified() {
                // Wenn "Auftragsbestätigung"
                if (this.productFileModel.type === 'ORDER_CONFIRMATION') {
                    return false;
                }

                // Wenn "Finale Druckdaten"
                if (this.productFileModel.type === 'PRINTING_DATA' && this.areFinalPrintData) {
                    return false
                }

                // Wenn "Freigabe-PDF"
                if (this.productFileModel.type === 'FORM_PROOF') {
                    // Wenn Benutzer kein Zmuekish-User und kein Lieferant ist
                    if (!this.$auth.isZmuekish && this.$auth.activeRole !== 'SUPPLIER') {
                        return false
                    }

                    // Freigabe durch MP oder Auftraggeber erfolgt
                    if (this.releasedByMediaProduction || this.releasedByPurchaser) {
                        return false
                    }
                }

                // Ansonsten Komponenten-Option beachten
                return R.contains('changeType', this.actions)
            },

            canDownload() {
                return R.contains('download', this.actions)
            },

            canHashlink() {
                return this.$auth.isZmuekish && R.contains('hashlink', this.actions)
            },

            date() {
                return to_ddmmyyyy(this.fileModel.createdAt)
            },

            firstReviewUserId() {
                return R.propIs(Number, 'firstReviewUserId', this.productFileModel)
            },

            hashlinkModels() {
                return this.$store.getters['hashlinks/allByFileId'](this.fileModel.id)
            },

            isProcessed() {
                return R.prop('isProcessed', this.fileModel)
            },

            releasedByMediaProduction() {
                return R.prop('releasedByMediaProduction', this.productFileModel)
            },

            releasedByPurchaser() {
                return R.prop('releasedByPurchaser', this.productFileModel)
            },

            size() {
                return to_mb(this.fileModel.size)
            },

            time() {
                return to_hhmm(this.fileModel.createdAt)
            },

            secondReviewUserId() {
                return R.propIs(Number, 'secondReviewUserId', this.productFileModel)
            },

            type() {
                return R.cond([
                    [R.equals('SKETCH'),        R.always('Skizze')],
                    [R.equals('PRINTING_DATA'), R.always('Druckdaten')],
                    [R.equals('OUTLINE_PUNCH'), R.always('Kontur/Stanze')],
                    [R.equals('DELIVERY_NOTE'), R.always('Lieferschein')],
                    [R.equals('FORM_PROOF'),    R.always('Freigabe-PDF')],
                    [R.equals('MAILING_LIST'),  R.always('Adressverteiler')],
                    [R.equals('ORDER_CONFIRMATION'), R.always('Auftragsbestätigung')],
                    [R.equals('OTHER'),         R.always('Andere')],
                    [R.T,                       v => `Unbekannt (${v})`],
                ])(this.productFileModel.type)
            },

        },

        data() {
            return {
                areFinalPrintDataElId: `${this.$rndId()}-are-final-print-data-id`,
                firstReviewUserIdElId: `${this.$rndId()}-first-review-user-id`,
                releasedByMediaProductionElId: `${this.$rndId()}-released-by-media-production`,
                releasedByPurchaserElId: `${this.$rndId()}-released-by-purchaser`,
                secondReviewUserIdElId: `${this.$rndId()}-second-review-user-id`,
                isTypeEditModeOn: false,
            }
        },

        created() {
            if (R.propEq('isProcessed', false, this.fileModel)) {
                setTimeout(this.waitOnModel, 250)
            }
        },

        mounted() {
            if (this.canModified) {
                jQuery(this.$refs.typeDropdown).dropdown({
                    onChange: this.onTypeChange,
                })
            }
        },

        methods: {

            closeHashlinkModal() {
                this.$refs.hashlinkModal.close()
            },

            download() {
                window.open(`${location.origin}/downloads/${this.fileModel.id}`, '_blank')
            },

            async onTypeChange(value) {
                // Model erstellen
                const model = R.assoc('type', value, this.productFileModel)

                const typeLabels = {
                    MAILING_LIST:       'Adressverteiler',
                    PRINTING_DATA:      'Druckdaten',
                    FORM_PROOF:         'Freigabe-PDF',
                    OUTLINE_PUNCH:      'Kontur/Stanze',
                    DELIVERY_NOTE:      'Lieferschein',
                    SKETCH:             'Skizze',
                    OTHER:              'Sonstiges',
                }

                try {
                    // ProductFile speichern
                    await this.$store.dispatch('productFiles/update', { id: model.id, model })

                    // Erfolgsmeldung anzeigen
                    const label = typeLabels[value] || value
                    this.$growl.info(`Datei-Typ wurde auf „${label}" gesetzt`)

                } catch (e) {
                    // Spezifische Fehlercodes behandeln
                    const errorCode = e && e.response && e.response.data && e.response.data.errors && e.response.data.errors[0] && e.response.data.errors[0].code
                    if (errorCode === 'FORM_PROOF_IS_ALREADY_CONFIRMED') {
                        this.$growl.warning('Typ kann nicht geändert werden: Das Freigabe-PDF wurde bereits bestätigt.')
                    } else {
                        this.$growl.fatal('Datei-Typ konnte nicht geändert werden.', e)
                    }
                }
            },

            async persistProperty(property, confirmMessage, value, successMessage = 'Upload wurde gespeichert', warningMessage = null) {
                // Fragen, ob Upload gespeichert werden soll
                if (!await this.$growl.confirm(confirmMessage)) {
                    return
                }

                // Meldung je nach Zustand wählen
                const isWarning = !value && !!warningMessage
                const message = isWarning ? warningMessage : successMessage

                // Model aktualisieren und speichern
                await this.update(R.assoc(property, value, this.productFileModel), message, isWarning)

                // Produkt neu laden
                this.$store.dispatch('products/loadOne', { id: this.productFileModel.product, force: true })
            },

            async persistUserIdToProperty(property, confirmMessage, checked, successMessage = 'Upload wurde gespeichert', warningMessage = null) {
                // Benutzer-ID holen oder nullen
                const value = checked ? this.$auth.userId : null

                await this.persistProperty(property, confirmMessage, value, successMessage, warningMessage)
            },

            async remove() {
                // Sicherheitsfrage
                if (!await this.$growl.confirm('Soll diese Datei wirklich gelöscht werden?')) {
                    return false
                }

                try {
                    // Datei loeschen
                    await this.$store.dispatch('productFiles/remove', {model: this.productFileModel})

                    // Infomeldung anzeigen
                    this.$growl.info('Datei wurde gelöscht')

                } catch(e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Datei konnte nicht gelöscht werden', e)
                }
            },

            async showHashlinkModal() {
                await this.$store.dispatch('hashlinks/loadAllByFileId', { fileId: this.fileModel.id })
                this.$refs.hashlinkModal.show()
            },

            async update(model, message = 'Upload wurde gespeichert', isWarning = false) {
                try {
                    // Model speichern
                    await this.$store.dispatch('productFiles/update', { id: model.id, model })

                    // Erfolgs- oder Warnmeldung anzeigen
                    if (isWarning) {
                        this.$growl.warning(message)
                    } else {
                        this.$growl.success(message)
                    }

                } catch(e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Upload konnte nicht gespeichert werden', e)
                }
            },

            async waitOnModel() {
                // File laden
                const fileModel = await this.$store.dispatch('files/loadOne', {
                    id: this.fileModel.id,
                    force: true,
                    silent: true
                })

                // Wenn Datei noch nicht verarbeitet wurden, dann in 750 ms wieder laden
                if (R.propEq('isProcessed', false, fileModel)) {
                    setTimeout(() => this.waitOnModel(fileModel.id), 750)
                }
            },

        },

        props: {

            actions: {
                type: Array,
                default: () => [ 'delete', 'hashlink', 'download', 'changeType' ]
            },

            canBeFormProof: {
                type: Boolean,
                default: true
            },

            canBePrintingData: {
                type: Boolean,
                default: true
            },

            fileModel: {
                type: Object,
                required: true
            },

            hideDetails: {
                type: Boolean,
                default: false,
            },

            productFileModel: {
                type: Object,
                required: true
            }

        }

    }

</script>


<!--suppress CssUnusedSymbol -->
<style scoped>

    .head {
        overflow: hidden;
        white-space: nowrap;
    }

    .ui.form {
        padding-top: 1rem;
    }

</style>
